import { render, staticRenderFns } from "./EventCancellationModal.vue?vue&type=template&id=d824f824&"
import script from "./EventCancellationModal.vue?vue&type=script&lang=ts&"
export * from "./EventCancellationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports